// extracted by mini-css-extract-plugin
export var ctnWrapper = "about-module--ctnWrapper--Oga9-";
export var imgCtn = "about-module--imgCtn--SS56J";
export var textCtn = "about-module--textCtn--5bLwm";